import { render } from "./HolidayNotification.vue?vue&type=template&id=11fa2990"
import script from "./HolidayNotification.vue?vue&type=script&lang=js"
export * from "./HolidayNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__